<a [href]="pubC?.link" target="_blank">
  <img  *ngIf="pubC?.imageName" [src]="publiciteImageUri + pubC?.imageName" width="100%" alt="" [title]="pubC?.titre" />
  <!--<img  *ngIf="!pubC?.imageName" src="assets/img/logo/pub2.png" width="100%" alt="" title="Pub C" />-->
</a>
